export default {
    devices_activate_simcard_title: "Activate Camera's SIM Card",
    devices_activate_simcard_label: "This process will activate camera's SIM cards. Do you want to continue?",
    devices_activate_simcard_label_single: "This process will activate camera SIM card. Do you want to continue?",
    devices_activate_simcard_device_name: "Device Name",
    devices_activate_simcard_serial: "Serial",
    devices_activate_simcard_response: "Response",
    devices_activate_simcard_yes: "Yes",
}